var map = {
	"./01.png": 2044,
	"./02.png": 9079,
	"./03.png": 6942,
	"./04.png": 1505,
	"./05.png": 9464,
	"./06.png": 1443,
	"./07.png": 1610,
	"./08.png": 4493,
	"./09.png": 1252,
	"./area1.png": 2629,
	"./area2.png": 6241,
	"./area3.png": 7847,
	"./area4.png": 5208,
	"./area5.png": 6337,
	"./area6.png": 5754
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1558;